//import gql from "graphql-tag";


export const headers = [
  { text: 'ACCIONES', groupable: false, value: 'actions', sortable: false, width: 120 },
  { text: 'OBSERVACIONES', value: 'observaciones' },
  { text: 'CATEGORIA', value: 'categoria' },
  { text: 'COD ACADEM', align: 'start', value: 'codigo_academico', width:120 },
  { text: '#MODULOS', value: 'nro_modulos'},
  { text: 'ID ESAM', value: 'id_esam',},
  { text: 'N', value: 'nro', groupable: false },
  { text: 'CI', value: 'ci', groupable: false },
  { text: 'APELLIDO', value: 'apellido', groupable: false },
  { text: 'NOMBRE', value: 'nombre', groupable: false },
  { text: 'SEDE', value: 'sede' },
  { text: 'M1', value: 'nota_m1', groupable: false },
  { text: 'M2', value: 'nota_m2' ,groupable: false},
  { text: 'M3', value: 'nota_m3' ,groupable: false},
  { text: 'M4', value: 'nota_m4' ,groupable: false},
  { text: 'M5', value: 'nota_m5' ,groupable: false},
  { text: 'M6', value: 'nota_m6' ,groupable: false},
  { text: 'M7', value: 'nota_m7' ,groupable: false},
  { text: 'M8', value: 'nota_m8' ,groupable: false},
  { text: 'M9', value: 'nota_m9' ,groupable: false},
  { text: 'M10', value: 'nota_m10' ,groupable: false},
  { text: 'M11', value: 'nota_m11' ,groupable: false},
  { text: 'M12', value: 'nota_m12' ,groupable: false},
  { text: 'M13', value: 'nota_m13' ,groupable: false},
  { text: 'M14', value: 'nota_m14' ,groupable: false},
  { text: 'M15', value: 'nota_m15' ,groupable: false},
  { text: 'M16', value: 'nota_m16' ,groupable: false},
  { text: 'M17', value: 'nota_m17' ,groupable: false},
  { text: 'M18', value: 'nota_m18' ,groupable: false},
  { text: 'M19', value: 'nota_m19' ,groupable: false},
  { text: 'M20', value: 'nota_m20' ,groupable: false},
  { text: 'PROMEDIO FINAL', value: 'promedio_final' },
  { text: 'ESTADO ACADEMICO', value: 'estado_academico' },
  { text: 'FECHA DE DEFENSA FINAL', value: 'fecha_defensa' },
  { text: 'ESTADO DE DEFENSA FINAL', value: 'estado_final' },
  { text: 'SEDE DE DEFENSA FINAL', value: 'sede_defensa' },
  { text: 'NOTA DE DEFENSA FINAL', value: 'nota_defensa' },
  { text: 'TITULO', value: 'estado_titulo' },
  
]
